import React from "react";
import { getDifficultyDetails } from "../../utils/LessonUtils";

const LessonCard = ({ lesson, onClick }) => {
  const { color, icon } = getDifficultyDetails(lesson.wpm);

  // Check if the lesson title length is greater than 5 and set to "Combined"
  const displayTitle = lesson.title.length > 5 ? "COMBINED" : lesson.title;

  return (
    <div
      className="lessonCard"
      onClick={() => onClick(lesson)}
      style={{ background: color }}
    >
      <div className="cardContent">
        <div className="iconContainer">
          <i className={icon}></i>
        </div>
        <div className="cardTitle">{displayTitle}</div>
        {lesson.wpm && <div className="cardWPM">WPM: {lesson.wpm}</div>}
        {lesson.lesson_number && (
          <div className="cardNumber">Lesson: {lesson.lesson_number}</div>
        )}
      </div>
    </div>
  );
};

export default LessonCard;
